<div class="dashletActivity">
  <img class="dashletActivity__icon" [src]="EIconPath.BASIC_FIELD_PRIORITY" />
  <div class="dashletActivity__text">
    {{ 'changed' | ppTranslate }}
    <span class="timeline__strong">{{ 'priority' | ppTranslate }}</span>
    {{ 'to' | ppTranslate | lowercase }}
    <strong class="timeline__strong activityChange--{{ color }}">{{ activityChange }}.</strong>
  </div>
</div>
